<path
    d="M25 4.34468C25 3.1491 23.4943 2.55033 22.6139 3.39576L7.687 17.8167H0L8.3984e-05 31.2365H7.15303L22.6139 45.6043C23.4943 46.4497 25 45.8508 25 44.6553V4.34468Z"
    fill="white"
/>
<path
    d="M46 18.8233L43.0002 16L37.4999 21.1767L31.9998 16.0001L29 18.8233L34.5001 24L29.0002 29.1764L32 31.9998L37.4999 26.8233L43 32L45.9998 29.1767L40.4997 24L46 18.8233Z"
    fill="white"
/>
